/* eslint-disable */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';
import FireSafety from '../components/FireSafety';
import UpdateModal from '../components/UpdateModal';

function FireSafetyContainer({
  fetchedDefaultOption,
  getFireSafetySettings,
  fireSafetySettings,
}) {
  const ordinanceRevisionId = parseInt(_.get(fetchedDefaultOption, 'year.value', 7));
  const setModal = useContext(ModalContext);
  const attrs = _.get(fireSafetySettings, 'attributes') || {};
  const fireSafetySettingsList = [
    {
      key: 'fsis_integration_enabled',
      label: 'FSIS Integration',
      value: !!_.get(attrs, 'fsis_integration_enabled'),
    },
  ];
  const transactionType = [
    { key: 'for_new', label: 'New', value: !!_.get(attrs, 'for_new') },
    { key: 'for_renewal', label: 'Renewal', value: !!_.get(attrs, 'for_renewal') },
    {
      key: 'exclude_delinquent',
      label: 'Exclude Delinquent',
      value: !!_.get(attrs, 'exclude_delinquent'),
    },
    {
      key: 'for_retirement',
      label: 'Retirement',
      value: !!_.get(attrs, 'for_retirement'),
    },
  ];

  useEffect(() => {
    getFireSafetySettings();
  }, []);

  const handleEdit = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          ordinanceRevisionId={ordinanceRevisionId}
          settings={attrs}
        />
      ),
      title: 'Fire Safety',
      modalSize: 'modal-md',
    });
  };

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body p-3 p-md-4">
        <div className="container-fluid p-0">
          <div className="row align-items-center">
            <div className="col-md-8 mb-3 mb-md-0">
              <h3 className="mb-1">FSIS Integration Settings</h3>
              <p className="mb-0 text-muted">
                Manage configuration and included fire safety inspection fees.
              </p>
            </div>
            <div className="col-md-4 d-flex justify-content-md-end">
              <button
                type="button"
                className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-round font-weight-bold px-4"
                onClick={handleEdit}
              >
                Update
              </button>
            </div>
            <div className="col-12 mt-3">
              <div className="border rounded p-3 p-md-4 bg-white">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="mb-0 font-weight-bold">Current Settings</div>
                </div>
                <div className="row w-50">
                  {fireSafetySettingsList.map((item) => (
                    <div className="col-12 mb-2" key={item.key}>
                      <div className="d-flex justify-content-between align-items-center px-3 py-2">
                        <span className="text-dark">{item.label}</span>
                        <span className={`p-1 badge ${item.value ? 'badge-success' : 'badge-secondary'}`}>
                          {item.value ? 'Enabled' : 'Disabled'}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="mb-0 font-weight-bold">Transaction Types</div>
                </div>
                <div className="row w-50">
                  {transactionType.map((item) => (
                    <div className="col-12 mb-2" key={item.key}>
                      <div className="d-flex justify-content-between align-items-center px-3 py-2">
                        <span className="text-dark">{item.label}</span>
                        <span className={`p-1 badge ${item.value ? 'badge-success' : 'badge-secondary'}`}>
                          {item.value ? 'Enabled' : 'Disabled'}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-12 mt-3">
              <FireSafety ordinanceRevisionId={ordinanceRevisionId} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

FireSafetyContainer.propTypes = {
  fetchedDefaultOption: PropTypes.instanceOf(Object),
  getFireSafetySettings: PropTypes.instanceOf(Function).isRequired,
  fireSafetySettings: PropTypes.instanceOf(Object),
};

FireSafetyContainer.defaultProps = {
  fetchedDefaultOption: {},
  fireSafetySettings: {},
};

const mapStateToProps = ({ api }) => {
  const fetchDefaultOption = () => {
    try {
      return JSON.parse(localStorage.getItem('defaultFormValue'));
    } catch (err) {
      return {};
    }
  };

  return {
    fetchedDefaultOption: fetchDefaultOption(),
    fireSafetySettings: _.get(api, `${c.GET_FIRE_SAFETY_SETTINGS}.item`) || {},
  };
};

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(FireSafetyContainer);
